
import { Group, GroupFromDB } from '@/types/group';

export const convertToGroup = (dbGroup: GroupFromDB & { user_count?: number }): Group => ({
  ...dbGroup,
  status: (dbGroup.status === 'active' || dbGroup.status === 'inactive') 
    ? dbGroup.status as 'active' | 'inactive' 
    : 'active',
  client: dbGroup.clients,
  responsible_user: dbGroup.responsible_user,
  user_count: dbGroup.user_count || 0,
  email: dbGroup.email,
  dias_semana: dbGroup.dias_semana || [],
  inicio_turno: dbGroup.inicio_turno,
  fim_turno: dbGroup.fim_turno
});
